export default {
  GET_DEALER_GROUPS: (state) => state.dealer_groups,
  GET_DEALER_GROUP: (state) => state.dealer_group,
};
